import React, { useState } from "react";
import { client } from "@/lib/api";
import { toast } from "sonner";

// WW-189 · wrong year cleanup. Preview first; apply needs the exact action count.
const box = { padding: 16, borderRadius: 14, border: "1px solid var(--ww-line)", background: "var(--ww-surface)" };
const btn = (bg, color) => ({ padding: "10px 16px", borderRadius: 10, border: `1px solid ${bg}`, background: bg, color,
  fontFamily: "Poppins", fontWeight: 700, fontSize: 13, textTransform: "lowercase", cursor: "pointer", minHeight: 40 });
const day = (s) => (s || "").slice(0, 10);

export const YearCleanupPanel = () => {
  const [preview, setPreview] = useState(null);
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setPreview((await client.get("/admin/year-cleanup/preview")).data); setTyped(""); }
    catch { toast.error("preview failed"); } finally { setBusy(false); }
  };
  const apply = async () => {
    setBusy(true);
    try {
      const r = await client.post("/admin/year-cleanup/apply", { confirm_count: Number(typed) });
      toast.success(r.data.noop ? "nothing to do" : `deleted ${r.data.deleted} · moved ${r.data.moved}`);
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail?.message || "apply failed"); } finally { setBusy(false); }
  };
  const n = preview?.actions_total ?? 0;
  const c = preview?.counts || {};
  return (
    <div data-testid="ops-card-year-cleanup" style={box}>
      <h2 style={{ fontFamily: "Poppins", fontWeight: 800, fontSize: 18 }}>WW-189 · wrong year cleanup</h2>
      <p style={{ fontFamily: "Arial", fontSize: 13, color: "var(--ww-text-muted)", marginTop: 4 }}>
        only events for 2026 onwards. before 2026 is deleted; a past 2026 date moves to its next same day and month. published events are never touched.
      </p>
      <button data-testid="year-cleanup-preview" className="mt-3" onClick={load} disabled={busy} style={btn("transparent", "var(--ww-text)")}>preview</button>
      {preview && (
        <div className="mt-3" style={{ fontFamily: "Arial", fontSize: 13 }}>
          <p data-testid="year-cleanup-summary">
            flagged <b>{preview.flagged}</b> · delete <b data-testid="year-cleanup-delete-count">{c.delete}</b> ·
            move <b data-testid="year-cleanup-move-count">{c.move}</b> · skip <b data-testid="year-cleanup-skip-count">{c.skip}</b>
          </p>
          <ul data-testid="year-cleanup-list" className="mt-2" style={{ maxHeight: 260, overflow: "auto" }}>
            {preview.rows.map((r) => (
              <li key={r.id} data-testid={`year-cleanup-row-${r.id}`}>
                <b>{r.action}</b> · {r.title} · {day(r.old_start)}
                {r.action === "move" && <> to {day(r.new_start)}</>}
                {r.action === "skip" && <> · {r.reason}</>}
              </li>
            ))}
          </ul>
          <div className="mt-3 flex items-center gap-2">
            <input data-testid="year-cleanup-confirm-input" value={typed} onChange={(e) => setTyped(e.target.value.replace(/\D/g, ""))}
              placeholder={`type ${n} to confirm`} style={{ height: 40, padding: "0 10px", borderRadius: 10, border: "1px solid var(--ww-line-strong)", background: "transparent", color: "var(--ww-text)" }} />
            <button data-testid="year-cleanup-apply" onClick={apply} disabled={busy || !n || Number(typed) !== n}
              style={{ ...btn("#D64545", "#FFFFFF"), opacity: busy || !n || Number(typed) !== n ? 0.5 : 1 }}>
              apply {n} actions
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
